export const getImgUrl = imgId => `/api/img/${imgId}`;
